import { MultiDayState } from './types';

export const WEEKDAY_ORDER = [1, 2, 3, 4, 5, 6, 0];

export const DEFAULT_MULTI_DAY: MultiDayState = {
  weekdays: [1, 2, 3, 4, 5],
  overrides: {},
};
